import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../globalState/hooks";
import { LoginRootState } from "../../../types/login";
import PageHeader from "../../../components/ui/PageHeader";
import ProfileChip from "../../../components/ui/ProfileChip";
import CodReportsTab from "../codSalesRep/CodReportsTab";
import { NJIM, pageShellSx } from "../codSalesRep/codStyles";

/** Standalone page: /codSalesRepReports — customer report for the logged-in sales rep. */
const CodSalesRepReportsPage: React.FC = () => {
  const { t } = useTranslation();
  const userDetails = useAppSelector((state: LoginRootState) => state.authReducer.loginDetials);
  const repName = `${userDetails?.firstName ?? ""} ${userDetails?.lastName ?? ""}`.trim();

  return (
    <Box sx={{ ...pageShellSx, maxWidth: 1440, mx: "auto" }}>
      <PageHeader
        title={t("codReports.pageTitle")}
        actions={repName ? <ProfileChip name={repName} role={t("codSalesRep.activeRep")} /> : undefined}
      />
      <Box
        sx={{
          borderRadius: "16px",
          border: `1px solid ${NJIM.border}`,
          background: NJIM.white,
          boxShadow: NJIM.elevation,
          p: { xs: 2, md: 3 },
        }}
      >
        <CodReportsTab repName={repName} />
      </Box>
    </Box>
  );
};

export default CodSalesRepReportsPage;
